module.exports = __webpack_public_path__ + "static/media/green-tick.f5980f08.svg";